import React from "react";
import { createPortal } from "react-dom";
import Close from "@mui/icons-material/Close";
import DeleteOutlineOutlined from "@mui/icons-material/DeleteOutlineOutlined";
import SaveOutlined from "@mui/icons-material/SaveOutlined";

interface SaveDiscardModalProps {
  show: boolean;
  onCancel: () => void;
  onDiscard: () => void;
  onSave: () => void;
}

const SaveDiscardModal: React.FC<SaveDiscardModalProps> = ({
  show,
  onCancel,
  onDiscard,
  onSave,
}) => {
  if (!show) {
    return null;
  }

  return createPortal(
    <div
      className="dom-save-discard-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Unsaved Price Changes"
    >
      <div className="dom-save-discard-modal">
        <div className="dom-save-discard-header">
          <h3 className="dom-save-discard-title">Unsaved Price Changes</h3>
          <button
            type="button"
            className="dom-save-discard-close-btn"
            aria-label="Close"
            onClick={onCancel}
          >
            <Close fontSize="small" />
          </button>
        </div>
        <p className="dom-save-discard-message">
          You have unsaved price edits on the Origins page. Would you like to
          save them before navigating away?
        </p>
        <div className="dom-save-discard-actions">
          <button
            type="button"
            className="dom-save-discard-btn dom-save-discard-cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="dom-save-discard-btn dom-save-discard-discard"
            onClick={onDiscard}
          >
            <DeleteOutlineOutlined
              className="dom-save-discard-btn-icon"
              fontSize="small"
            />
            Discard & Continue
          </button>
          <button
            type="button"
            className="dom-save-discard-btn dom-save-discard-save"
            onClick={onSave}
          >
            <SaveOutlined className="dom-save-discard-btn-icon" fontSize="small" />
            Save & Continue
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default SaveDiscardModal;
